import { Box, styled } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding: 0 !important;
  overflow: initial !important;
`;

export const Content = styled(Box)`
  height: 100vh;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 30px 0;
  overflow: auto;
`;

export const SubContainer = styled(Box)`
  overflow: hidden;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const SubContent = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-x: auto;
  padding: 20px 0;
`;
